import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import NeonTimeTunnelHero from '@/components/special-effects/neon-time-tunnel';
import BrandIntroSection from './components/BrandIntroSection';
import PublishingDirectionSection from './components/PublishingDirectionSection';
import Book2026Section from './components/Book2026Section';
import HomePartnerSection from './components/HomePartnerSection';
import HomeFaqSection from './components/HomeFaqSection';
import CtaSection from './components/CtaSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <NeonTimeTunnelHero />
        <BrandIntroSection />
        <PublishingDirectionSection />
        <Book2026Section />
        <HomePartnerSection />
        <HomeFaqSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}